/**
 * Tabs
 */

export default function Tabs() {
    const selectors = {
        'tabs' : '.js-tabs',
    };

    this.init = () => {
        this.tabs();
    };

    this.tabs = () => {
        jQuery(selectors.tabs).on('click', '.tab', (e) => {
            e.preventDefault();
            let $this = jQuery(e.currentTarget);
            let $parent = $this.closest(selectors.tabs);
            let tab = $this.data("tab");
            $this.addClass("active")
                .siblings().removeClass("active");
            $parent.find(".tab-content."+tab+"-form").addClass("active")
                .siblings().removeClass("active");
        })
    }

}
